import {memo, useEffect, useMemo} from "react";
import {Radar} from "@ant-design/charts";

const CompareRadarChart = memo(({data}) => {

    const maxDisplayPercentage = useMemo(() => {
        let max = Math.max(...data.map(e => e.percentage));
        return max > 50 ? 100 : (max > 25 ? 50 : 25)
    }, [data])

    const config = {
        data: data,
        xField: 'skill',
        yField: 'percentage',
        seriesField: 'scope',
        meta: {
            percentage: {
                alias: 'ร้อยละ',
                min: 0,
                max: maxDisplayPercentage,
            },
        },
        xAxis: {
            line: null,
            tickLine: null,
            grid: {
                line: {
                    style: {
                        lineDash: null,
                    },
                },
            },
        },
        yAxis: {
            line: null,
            tickLine: null,
            grid: {
                line: {
                    type: 'line',
                    style: {
                        lineDash: null,
                    },
                },
                alternateColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        point: {
            size: 2
        },
    };

    return <Radar {...config} />
});

export default CompareRadarChart;
